import React from 'react';

import { MainTablePage } from '../../components/MainTablePage';
import { PageRoutesEnum } from '../../utils/routes';

import { ClientsSearchForm } from './ClientsSearchForm';
import { useClientsTableColumnDefinitions } from './useClientsTableColumnDefinitions';
import { useClientsTableDataSource } from './useClientsTableDataSource';
import { useDeleteClientFilter } from './useDeleteClientFilter';
import { useGetClientFilters } from './useGetClientsFilters';
import { useSaveClientFilter } from './useSaveClientFilter';
import { useSearchClients } from './useSearchClients';
import { useUpdateClientFilter } from './useUpdateClientFilter';

export const ClientsPage = () => (
  <MainTablePage
    getFilters={useGetClientFilters}
    saveFilter={useSaveClientFilter}
    updateFilter={useUpdateClientFilter}
    deleteFilter={useDeleteClientFilter}
    getColumnsDefinition={useClientsTableColumnDefinitions}
    search={useSearchClients}
    getDataSource={useClientsTableDataSource}
    storedFilterName="clientsFilter"
    storedPagingData="clientsPaging"
    title="Clients"
    searchForm={ClientsSearchForm}
    addPageRoute={PageRoutesEnum.clientAdd}
  />
);
